import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useSettingsService } from '../../../../apis/settings/useSettingsService';
import { ComplianceItem } from '../../../../apis/settings/settingsComplianceItem.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getComplianceDetailsKey = 'get-compliance-details';

export const useComplianceDetailsHook = (
  id: string,
  options?: Omit<
    UseQueryOptions<ComplianceItem | null, TQueryError>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<ComplianceItem | null, TQueryError> => {
  const { getComplianceDetails } = useSettingsService();

  return useQuery<ComplianceItem | null, TQueryError>({
    queryKey: [getComplianceDetailsKey, id],
    queryFn: () => getComplianceDetails(id),
    enabled: options?.enabled !== undefined ? options.enabled : !!id,
    ...options,
  });
};
